<template>
  <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

    <a class="sidebar-brand d-flex align-items-center justify-content-center" href="#">
      <div class="sidebar-brand-icon">
        <img src="" style="height: 3rem">
      </div>
      <div class="sidebar-brand-text mx-2">Qontraq</div>
    </a>

    <hr class="sidebar-divider my-0">

    <li class="nav-item" :class="{'active': current_route.match(new RegExp(data.link+'/*','g')) && data.link != '/'}" v-for="(data,index) in arr" :key="index">
      <div v-if="data.arr != null && data.arr.length > 0">
        <a class="nav-link " :class="{'collapsed': !current_route.match(new RegExp(data.link+'/*','g'))}" href="#" data-toggle="collapse" :data-target="'#collapseMenu'+index" aria-expanded="false" :aria-controls="'collapseMenu'+index">
          <i class="fas fa-fw fa-wrench"></i>
          <span>{{ data.name }}</span>
        </a>
        <div :id="'collapseMenu'+index" class="collapse" :class="{'show': current_route.match(new RegExp(data.link+'*','g'))}">
          <div class="bg-white py-2 collapse-inner rounded">
            <a class="collapse-item" :class="{'active': (host+current_route).match(new RegExp(data1.link+'/*','g'))}" :href="data1.link" v-for="(data1,index1) in data.arr" :key="index1">{{ data1.name }}</a>
          </div>
        </div>
      </div>
      <div v-else>
        <a class="nav-link"  :href="data.link">
          <i class="fas fa-fw fa-briefcase"></i>
          <span>{{ data.name }}</span>
        </a>
      </div>
    </li>

    <div class="text-center d-none d-md-inline">
      <button class="rounded-circle border-0" id="sidebarToggle"></button>
    </div>

  </ul>
</template>

<script>
export default {
  created(){
    this.host = "http://"+location.hostname+':'+location.port
    this.current_route = this.$router.currentRoute.path
  },
  data(){
    return {
      host: '',
      current_route: '',
      arr:[
        {
          name: 'Analisa Data',
          link: '/',
        },
        {
          name: 'User',
          link: '/user',
        },
        {
          name: 'Banner',
          link: '/banner',
        },
        {
          name: 'Point',
          link: '/point',
        },
        {
          name: 'News',
          link: '/news',
        },
				{
					name: 'Job',
					link: '/jobs',
				},
        // {
        //   name: 'Online Test',
        //   link: '/online-test',
        // },
        {
          name: 'Order',
          link: '/order',
        },
				{
					name: 'Order Membership',
					link: '/order-membership',
				},
        // {
        //   name: 'Order Call',
        //   link: '/order-call',
        // },
        // {
        //   name: 'Order Recruit',
        //   link: '/order-recruit',
        // },
        {
          name: 'Kontrak kerja',
          link: '/contract',
        },
        // {
        //   name: 'List Referral',
        //   link: '/referral',
        // },
        {
          name: 'Communication',
          link: '/communication',
        },
        // {
        //   name: 'Article',
        //   link: '/article',
        // },
        // {
        //   name: 'Voucher',
        //   link: '/voucher',
        // },
        // {
        //   name: 'Discount',
        //   link: '/discount',
        // },
        // {
        //   name: 'List Job',
        //   link: '/job',
        // },
        {
          name: 'Master',
          link: '/master',
          arr:[
            {
              name: 'App Version',
              link: '/master/app-version',
            },
            {
              name: 'Experience',
              link: '/master/experience',
            },
            {
              name: 'Expected Salary',
              link: '/master/expected-salary',
            },
            {
              name: 'Contract Type',
              link: '/master/contract-type',
            },
            // {
            //   name: 'Bundle Packet',
            //   link: '/master/bundle-packet',
            // },
            // {
            //   name: 'Religion',
            //   link: '/master/religion',
            // },
            // {
            //   name: 'Tribes',
            //   link: '/master/tribe',
            // },
            {
              name: 'Helper Category',
              link: '/master/helper-category',
            },
            {
              name: 'Helper Sub Category',
              link: '/master/helper-sub-category',
            },
            // {
            //   name: 'Helper Sub Sub Category',
            //   link: '/master/helper-sub-sub-category',
            // },
            {
              name: 'Province',
              link: '/master/province',
            },
            {
              name: 'City',
              link: '/master/city',
            },
            // {
            //   name: 'Nominal Point',
            //   link: '/master/nominal-point',
            // },
            // {
            //   name: 'Sub District',
            //   link: '/master/sub-district',
            // },
            // {
            //   name: 'Skill',
            //   link: '/master/skill',
            // },
            // {
            //   name: 'Education',
            //   link: '/master/education',
            // },
            // {
            //   name: 'Blood Type',
            //   link: '/master/blood-type',
            // },
            {
              name: 'Communication Method',
              link: '/master/communication-method',
            },
            {
              name: 'Communication Type',
              link: '/master/communication-type',
            },

          ]
        },
        {
          name: 'Setting',
          link: '/setting',
          arr: [
            {
              name: 'Point',
              link: '/setting/point',
            },
						{
							name: 'General',
							link: '/setting',
						},
            {
              name: 'Email',
              link: '/setting/email',
            },
            {
              name: 'Price',
              link: '/setting/price',
            },
            // {
            //   name: 'Company',
            //   link: '/setting',
            // },
            // {
            //   name: 'Referral',
            //   link: '/setting/referral',
            // },
            // {
            //   name: 'Interval Publish',
            //   link: '/setting/interval',
            // },
          ]
        },
        {
          name: 'Aduan',
          link: '/support',
        },
      ]
    }
  },
}
</script>
